/**
 * Phase_BugGroupsEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { PhaseEntity } from "../PhaseEntity";
import { BugGroupEntity } from "../BugGroupEntity";
import { Phase_BugGroupsEntity } from "../Phase_BugGroupsEntity";
declare global {
    interface EntityTypeMap {
        Phase_BugGroups: Phase_BugGroupsEntity;
    }
}
export abstract class Phase_BugGroupsGeneratedEntity extends BaseEntity {
    public abstract relationId: string;
    public abstract templateId: string | null;
    public abstract phase: PhaseEntity;
    public abstract bugGroup: BugGroupEntity | null;
}
